// ajay:code 19-08-26
import { Plus, X } from "lucide-react";

// Reusable "+Add line" list — used wherever a cell in the source Excel holds
// a variable number of lines (Effects, Prevention Control, Detection
// Control, Action Taken). Each line is its own input + delete button, so
// entries stay clearly separated instead of one big free-text box.
export default function MultiLineList({
  label,
  lines = [],
  onChange,
  readOnly = false,
  placeholder = "",
}) {
  const updateLine = (i, value) => {
    const next = [...lines];
    next[i] = value;
    onChange(next);
  };
  const addLine = () => onChange([...lines, ""]);
  const removeLine = (i) => onChange(lines.filter((_, idx) => idx !== i));

  return (
    <div style={{ marginBottom: 8 }}>
      {label && (
        <div
          style={{
            fontSize: 10,
            color: "var(--text3)",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: 0.4,
            marginBottom: 4,
          }}
        >
          {label}
        </div>
      )}

      {lines.length === 0 && readOnly && (
        <div style={{ fontSize: 12, color: "var(--text3)" }}>—</div>
      )}

      {lines.map((line, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            gap: 6,
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          {readOnly ? (
            <div style={{ fontSize: 12, color: "var(--text)", flex: 1 }}>
              {line || "—"}
            </div>
          ) : (
            <>
              <input
                type="text"
                value={line}
                placeholder={placeholder}
                onChange={(e) => updateLine(i, e.target.value)}
                style={{
                  flex: 1,
                  padding: "4px 8px",
                  fontSize: 12,
                  borderRadius: 6,
                  border: "1px solid var(--border2)",
                  background: "var(--surface2)",
                  color: "var(--text)",
                }}
              />
              <button
                type="button"
                title="Remove line"
                onClick={() => removeLine(i)}
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--danger)",
                  cursor: "pointer",
                  display: "flex",
                  padding: 2,
                }}
              >
                <X size={13} />
              </button>
            </>
          )}
        </div>
      ))}

      {!readOnly && (
        <button
          type="button"
          onClick={addLine}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            background: "none",
            border: "1px dashed var(--border2)",
            borderRadius: 6,
            padding: "3px 8px",
            fontSize: 11,
            color: "var(--accent)",
            cursor: "pointer",
            marginTop: 2,
          }}
        >
          <Plus size={11} /> Add {label ? label.toLowerCase() : "line"}
        </button>
      )}
    </div>
  );
}
